import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  LinearProgress,
  Box,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import RemoveIcon from '@material-ui/icons/Remove';

const ColoredLinearProgress = withStyles({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: '#e0e0e0',
  },
  bar: {
    borderRadius: 5,
  },
})(LinearProgress);

const getProgressColor = (taux) => {
  if (taux < 20) return '#f44336'; // Rouge
  if (taux < 40) return '#ff9800'; // Orange
  return '#4caf50'; // Vert
};

const VariationCell = ({ variation }) => {
  if (variation === null || variation === undefined) return <span>-</span>;

  const isPositive = variation > 0;
  const isNegative = variation < 0;

  const color = isPositive ? '#4caf50' : isNegative ? '#f44336' : '#9e9e9e';
  const Icon = isPositive ? TrendingUpIcon : isNegative ? TrendingDownIcon : RemoveIcon;

  return (
    <Box display="flex" alignItems="center" justifyContent="flex-end" style={{ color }}>
      <Icon style={{ fontSize: 16, marginRight: 2 }} />
      <span style={{ fontWeight: 500 }}>
        {isPositive ? '+' : ''}{variation.toFixed(1)}%
      </span>
    </Box>
  );
};

const formatCurrency = (value) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }).format(value);
};

const AdoptionTable = ({ data = [], subtitle }) => {
  // Tri par taux décroissant
  const sortedData = [...data].sort((a, b) => b.taux_adoption - a.taux_adoption);

  return (
    <Card>
      <CardContent>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          Adoption par Entreprise
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginBottom: 8 }}>
            {subtitle}
          </Typography>
        )}
        <TableContainer style={{ maxHeight: 400 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Entreprise</TableCell>
                <TableCell align="right">Commandes</TableCell>
                <TableCell align="right">Évol.</TableCell>
                <TableCell align="right">CA Total</TableCell>
                <TableCell align="right">Marge nette (10%)</TableCell>
                <TableCell align="center">Utilisateurs qui ont commandé</TableCell>
                <TableCell align="center">Inscrits</TableCell>
                <TableCell style={{ minWidth: 150 }}>Adoption</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedData.map((row) => (
                <TableRow key={row.entreprise_id} hover>
                  <TableCell>{row.nom}</TableCell>
                  <TableCell align="right">{row.nb_commandes || 0}</TableCell>
                  <TableCell align="right">
                    <VariationCell variation={row.variation_commandes} />
                  </TableCell>
                  <TableCell align="right">{formatCurrency(row.ca_total || 0)}</TableCell>
                  <TableCell align="right">{formatCurrency(row.marge_nette || 0)}</TableCell>
                  <TableCell align="center">{row.commandeurs}</TableCell>
                  <TableCell align="center">{row.total_inscrits}</TableCell>
                  <TableCell>
                    <Box display="flex" alignItems="center">
                      <Box width="100%" mr={1}>
                        <ColoredLinearProgress
                          variant="determinate"
                          value={Math.min(row.taux_adoption, 100)}
                          style={{
                            backgroundColor: '#e0e0e0',
                          }}
                          // Override bar color with inline style
                          classes={{
                            bar: undefined,
                          }}
                        />
                        {/* Overlay with colored bar */}
                        <div
                          style={{
                            position: 'relative',
                            marginTop: -10,
                            height: 10,
                            borderRadius: 5,
                            backgroundColor: getProgressColor(row.taux_adoption),
                            width: `${Math.min(row.taux_adoption, 100)}%`,
                          }}
                        />
                      </Box>
                      <Box minWidth={50}>
                        <Typography
                          variant="body2"
                          style={{ color: getProgressColor(row.taux_adoption) }}
                        >
                          {row.taux_adoption.toFixed(1)}%
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default AdoptionTable;
